import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import React from "react";
import { useNavigate } from "react-router";
import { AssetAttrsDetails } from "../../interfaces/api";
import DocumentDisplay from "./DocumentDisplay";

interface ProcessingDetailsProps {
  asset: AssetAttrsDetails;
  setCurrentDocId: Function;
  setDocPages: Function;
}

const ProcessingDetails: React.FC<ProcessingDetailsProps> = ({
  asset,
  setCurrentDocId,
  setDocPages,
}) => {
  const navigate = useNavigate();
  const documentCores = _(asset.processing!.review!.analysis)
    .groupBy("document_id")
    .pickBy((_, docId) => asset.documents.map((doc) => doc._id).includes(docId))
    .value();
  if (!documentCores) {
    return <div>Votre processing est en cours</div>;
  } else {
    return (
      <Stack className="gap-2">
        {_.entries(documentCores).map(([documentId, cores]) => {
          const document = asset.documents.find(
            (doc) => doc._id === documentId
          )!;
          if (cores.length > 1) {
            return (
              <Paper
                className="flex flex-col gap-2 p-2 border-[var(--mui-palette-primary-main)] border-solid border-1"
                key={document.name}
              >
                <div className="flex justify-between w-full items-center mb-2">
                  <div className="flex">
                    <InsertDriveFile className="text-gray-400" />
                    <Typography className="ml-2 font-bold">
                      {document.name}
                    </Typography>
                  </div>
                </div>
                {cores.map((coreResult) => {
                  const coreIdx = asset.processing!.review!.analysis.findIndex(
                    (core) => core === coreResult
                  );
                  const validation =
                    asset.processing!.review!.validation?.document_validations[
                      coreIdx
                    ];
                  return (
                    <DocumentDisplay
                      key={coreIdx}
                      coreResult={coreResult}
                      validation={validation}
                      setPdf={() => {
                        setCurrentDocId(document._id);
                        setDocPages(coreResult.page_subset);
                      }}
                      toEdit={() =>
                        navigate(
                          `/orion/processing/${asset.processing!._id}/${coreIdx}`
                        )
                      }
                    />
                  );
                })}
              </Paper>
            );
          } else {
            const coreResult = cores[0];
            const coreIdx = asset.processing!.review!.analysis.findIndex(
              (core) => core === coreResult
            );
            const validation =
              asset.processing!.review!.validation?.document_validations[
                coreIdx
              ];
            return (
              <DocumentDisplay
                key={document.name}
                title={document.name}
                coreResult={coreResult}
                validation={validation}
                setPdf={() => {
                  setCurrentDocId(document._id);
                  setDocPages(undefined);
                }}
                toEdit={() =>
                  navigate(
                    `/orion/processing/${asset.processing!._id}/${coreIdx}`
                  )
                }
              />
            );
          }
        })}
      </Stack>
    );
  }
};

export default ProcessingDetails;
